import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const breadcrumbSchema = buildBreadcrumb([{ name: "Política de privacidad", path: "/legal/privacidad" }]);

export const Route = createFileRoute("/legal/privacidad")({
  head: () => ({
    meta: [
      { title: "Política de Privacidad | SEOEVOLUTION" },
      { name: "description", content: "Política de privacidad completa de SEOEVOLUTION SL. Información sobre tratamiento de datos, cookies, Consent Mode v2 y tus derechos bajo RGPD." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/legal/privacidad" },
      { property: "og:title", content: "Política de Privacidad | SEOEVOLUTION" },
      { property: "og:description", content: "Política de privacidad completa de SEOEVOLUTION SL. Información sobre tratamiento de datos, cookies, Consent Mode v2 y tus derechos bajo RGPD." },
      { name: "twitter:title", content: "Política de Privacidad | SEOEVOLUTION" },
      { name: "twitter:description", content: "Política de privacidad completa de SEOEVOLUTION SL. Información sobre tratamiento de datos, cookies, Consent Mode v2 y tus derechos bajo RGPD." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/legal/privacidad" }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: PrivacyPolicy,
});
